import { GET_CAFETERIA_MASTER_WATCHER, SAVE_CAFETERIA_WATCHER, DELETE_CAFETERIA_WATCHER, CAFETERIA_MASTER_LIST } from "../../actionTypes/admin";

export function getCafeteriaMasterWatcher() {
    return { type: GET_CAFETERIA_MASTER_WATCHER };
}

export function saveCafeteriaWatcher(data, setOpen) {
    return { type: SAVE_CAFETERIA_WATCHER, payload: data, setOpen };
}

export function deleteCafeteriaWatcher(id) {
    return { type: DELETE_CAFETERIA_WATCHER, id };
}

export function cafeteriaMasterList(data) {
    return { type: CAFETERIA_MASTER_LIST, payload: data };
}
